import type { StateCreator } from 'zustand/vanilla';
import type { LiveAvatar, LiveExitNotice, StoredLiveClaimSession } from '@/app/types';

interface LiveStoreState {
  /** 当前选中的头像，全局挂载，通话模块共用。 */
  liveAvatar: LiveAvatar | null;
  /** 当前正在使用的 live claim 会话。 */
  liveSession: StoredLiveClaimSession | null;
  /** 通话页非主动退出的提示；返回 /live 后读取并展示，消费后清空。null 表示无待提示。 */
  exitNotice: LiveExitNotice | null;
}

export interface LiveStore extends LiveStoreState {
  /** 设置当前选中头像。 */
  setLiveAvatar: (avatar: LiveAvatar) => void;
  /** 设置当前 live claim 会话。 */
  setLiveSession: (session: StoredLiveClaimSession) => void;
  /** 清空当前 live claim 会话。 */
  clearLiveSession: () => void;
  /** 还原为默认头像。 */
  resetLiveAvatar: () => void;
  /** 记录一次非主动退出提示，供返回 /live 后展示。 */
  setLiveExitNotice: (notice: LiveExitNotice) => void;
  /** 清空退出提示（展示后调用，避免重复弹窗）。 */
  clearLiveExitNotice: () => void;
}

const initialState: LiveStoreState = {
  liveAvatar: null,
  liveSession: null,
  exitNotice: null,
};

export const createLiveSlice: StateCreator<LiveStore, [], [], LiveStore> = (set) => ({
  ...initialState,

  setLiveAvatar: (liveAvatar) => {
    set({ liveAvatar });
  },

  setLiveSession: (liveSession) => {
    set({ liveSession });
  },

  clearLiveSession: () => {
    set({ liveSession: null });
  },

  resetLiveAvatar: () => {
    set(initialState);
  },

  setLiveExitNotice: (exitNotice) => {
    set({ exitNotice });
  },

  clearLiveExitNotice: () => {
    set({ exitNotice: null });
  },
});
